/**
 * @module constants
 */

/**
 * @constant
 * A client identifier name for OWA in Actionable Messages
 */

export const CLIENT_TYPE = 'WAC_Outlook_React';

/**
 * @constant
 * A string representing the mailbox is group mailbox
 */

export const GROUP_MAILBOX = 'GroupMailbox';

/**
 * @constant
 * A type name for inline adaptive card
 */

export const INLINE_ADAPTIVE_CARD_TYPE = 'InlineAdaptiveCard';

/**
 * @constant
 * Event name for logging telemetry when Http post action clicked on a show card
 */

export const ACTION_CARD_POST_ACTION_CLICKED = 'ActionCardHttpPostActionClicked';

/**
 * @constant
 * Event name for logging telemetry when http post action clicked on a card
 */

export const SINGLE_CLICK_POST_ACTION_CLICKED = 'SingleClickHttpPostActionClicked';

/**
 * @constant
 * Event name for logging telemetry when auto invoke action is fired
 */

export const AUTO_INVOKE_ACTION_CLICKED = 'AutoInvokeActionClicked';

/**
 * @constant
 * A default id for an action
 */

export const DEFAULT_ACTION_ID = '30d2f5e2-6e6f-43b0-a2bd-c9d87a5cd6fd';

/**
 * @constant
 * Aria event name for client event
 */

export const ARIA_CLIENT_EVENT = 'client_event';

/**
 * @constant
 * A fallback client version for Actionable Message service requests
 */

export const FALLBACK_CLIENT_VERSION = '20000101001';
